export default __webpack_public_path__ + "9ba40e5f9abef44bf8f2eaf1867744f4.svg";